/** Formats the backend-provided Stripe date without calculating expiry. */
export function formatSubscriptionTrialEnd(
  value: string | null | undefined
): string | null {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return new Intl.DateTimeFormat(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  }).format(date);
}

export function resolveTrialAccessCopy(
  subscriptionStatus: string | null | undefined,
  subscriptionTrialEnd: string | null | undefined,
  extensionSource: boolean
): { headline: string; detail: string } | null {
  if (subscriptionStatus !== 'trialing') return null;
  const trialEnd = formatSubscriptionTrialEnd(subscriptionTrialEnd) ?? 'date unavailable';
  return {
    headline: 'Your 21-day trial is active.',
    detail: extensionSource
      ? `Full access through ${trialEnd}. Close this tab and open any page.`
      : `Full access through ${trialEnd}. Add a payment method any time in the Stripe portal.`
  };
}
